import { c as create_ssr_component, v as validate_component, e as escape } from "./ssr.js";
import "./util.js";
import { N as NotEditable } from "./NotEditable.js";
const Footer = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { counter = void 0 } = $$props;
  let { editable = false } = $$props;
  if ($$props.counter === void 0 && $$bindings.counter && counter !== void 0)
    $$bindings.counter(counter);
  if ($$props.editable === void 0 && $$bindings.editable && editable !== void 0)
    $$bindings.editable(editable);
  return `${validate_component(NotEditable, "NotEditable").$$render($$result, { editable }, {}, {
    default: () => {
      return `<div class=""><div class="max-w-screen-md mx-auto px-6 py-6 text-sm lg:text-base"><div class="text-center">Powered by <a class="underline font-medium" href="https://www.postowl.com" data-svelte-h="svelte-fhommr">PostOwl</a>. Page
        viewed ${escape("…")} times.</div></div></div>`;
    }
  })}`;
});
export {
  Footer as F
};
